import { getApiInstance } from './api';

export interface SubscriptionPlan {
  id: number;
  name: string;
  account_type: string;
  day_count: number;
  price: number;
  display_name?: string | null;
  athlete_limit?: number;
  unlimited?: boolean;
  athlete_unit_price?: number | null;
  max_athletes?: number | null;
}

export interface SubscriptionQuote {
  price_id: number;
  base_amount: number;
  discount_amount: number;
  tax_amount: number;
  credit_amount: number;
  cash_amount: number;
  currency: string;
  duration: number;
  athlete_limit: number;
  unlimited: boolean;
  discount_code?: string;
  discount_type?: string;
}

export interface SubscriptionOrder {
  id: number;
  user_id: number;
  price_id: number;
  status: number;
  cash_amount: number;
  currency: string;
  duration: number;
  created_at: string;
  payment_due_at?: string;
  ends_at?: string;
}

export const subscriptionApi = {
  async plans(role: 'coach' | 'athlete', signal?: AbortSignal) {
    const { data } = await getApiInstance().get<{ plans: Record<string, SubscriptionPlan[]> }>(
      '/api/v1/mobile/app/plans', { params: { role }, signal },
    );
    return (data.plans[role] ?? []).filter(p => (Number(p.price) > 0 || p.athlete_unit_price != null) && Number(p.day_count) > 0);
  },
  async quote(priceId: number, signal?: AbortSignal, discountCode?: string, athleteCount?: number) {
    const { data } = await getApiInstance().post<{ data: SubscriptionQuote }>(
      '/api/v1/mobile/purchases/quote', { price_id: priceId, use_credit: false, discount_code: discountCode || undefined, athlete_count: athleteCount }, { signal },
    );
    return data.data;
  },
  async orders(signal?: AbortSignal) {
    const { data } = await getApiInstance().get<{ data: SubscriptionOrder[] }>(
      '/api/v1/mobile/purchases', { signal },
    );
    return data.data;
  },
  async create(priceId: number, requestKey: string, discountCode?: string, athleteCount?: number) {
    const { data } = await getApiInstance().post<{ data: SubscriptionOrder }>(
      '/api/v1/mobile/purchases', { price_id: priceId, use_credit: false, request_key: requestKey, discount_code: discountCode || undefined, athlete_count: athleteCount },
    );
    return data.data;
  },
};
